// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2dzhY","vLegacy":"SelectSecondary_vLegacy__NgtVV","error":"SelectSecondary_error__2xfQ7","disabled":"SelectSecondary_disabled__1j1SB"};